import { render, staticRenderFns } from "./TheAgentTransfer.vue?vue&type=template&id=6368a975&scoped=true"
import script from "./TheAgentTransfer.vue?vue&type=script&lang=js"
export * from "./TheAgentTransfer.vue?vue&type=script&lang=js"
import style0 from "./TheAgentTransfer.vue?vue&type=style&index=0&id=6368a975&prod&lang=css"
import style1 from "./TheAgentTransfer.vue?vue&type=style&index=1&id=6368a975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6368a975",
  null
  
)

export default component.exports